import React from 'react';
import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';
import './pagination.css';
const Pagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  let lastPage = paginationRange[paginationRange.length - 1];

  const onNext = () => {
    if(currentPage == lastPage)
        return false;
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    if(currentPage == 1)
        return false
    onPageChange(currentPage - 1);
  };

  return (
    <ul
      className={classnames('pagination', { [className]: className })}
    >
      <li
        className={classnames('page-item', {
          disabled: currentPage === 1
        })}
        style={{cursor:"pointer"}}
        onClick={onPrevious}
      >
        <a data-test="page-link" aria-label="Previous" className={classnames('page-link page-link', {
          disabled: currentPage === 1
        })}><span>Previous</span></a>
      </li>
      {paginationRange.map(pageNumber => {
        if (pageNumber === DOTS) {
          return <li className="page-item dots">&#8230;</li>;
        }

        return (
          <li
            className={classnames('page-item', {
              active: pageNumber === currentPage
            })}
            style={{cursor:"pointer"}}
            onClick={() => onPageChange(pageNumber)}
          >
            <a data-test="page-link" class="page-link page-link">{pageNumber}</a>
          </li>
        );
      })}
      <li
        className={classnames('page-item', {
          disabled: currentPage === lastPage
        })}
        style={{cursor:"pointer"}}
        onClick={onNext}
      >
        <a data-test="page-link" aria-label="Next" class="page-link page-link"><span>Next</span></a>
      </li>
    </ul>
  );
};

export default Pagination;
